<template>
  <li :class="['message', { active: isActive || isChecked }]">
    <a href="javascript:void()" @click="showExtensibleView()">
      <div class="actions">
        <span class="action ml-1"><b-form-checkbox v-model="isChecked"></b-form-checkbox></span>
      </div>
      <div class="header d-block">
        <span class="from">{{ extensible.heading }}</span>
        <span class="pull-right"><span class="badge badge-secondary badge-pill"> <small>{{!extensible.hasOwnProperty('items')?extensible.total_views:extensible.items.length}}</small></span></span>
      </div>
      <div class="description">
        {{url+extensible.slug}}
      </div>
    </a>
  </li>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex"
import {EventBus} from '@/events/bus.event'

export default {
  name: 'ExtensibleItem',
  components: {
  },
  data () {
    return {
      isChecked: false,
      url: process.env.VUE_APP_EXT_BASE_URL,
    }
  },
  props: {
    extensible: Object,
    isActive: {
      type: Boolean,
      default: false
    },
  },
  created: function() {
    EventBus.$on('extensible-selection-'+this.extensible.id, this.toggleSelection)
  },
  methods: {
    showExtensibleView: function() {
      if(!this.isChecked)
        this.$emit('show-extensible-view', this.extensible)
    },
    showExtensibleSelection: function(flag) {
      this.$emit('show-extensible-selection', this.extensible, flag)
    },
    toggleSelection: function(flag) {
      this.isChecked = flag
    },
  },
  watch: {
    isChecked: function (flag) {
      this.showExtensibleSelection(flag)
    },
  },
}
</script>

<style type="text/css" scoped>
div.media-container{
    width: 100%;
    height: 100%;
}
</style>